import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowDownIcon, ArrowRightIcon } from "lucide-react";
import { trackCheckoutIntent } from "../utils/metaPixel";
type CtaButtonProps = {
  children: React.ReactNode;
  className?: string;
  compact?: boolean;
  href?: string;
  continuation?: boolean;
};
export function CtaButton({
  children,
  className = "",
  compact = false,
  href = "#oferta",
  continuation = false
}: CtaButtonProps) {
  const reducedMotion = useReducedMotion();
  const ArrowIcon = continuation ? ArrowDownIcon : ArrowRightIcon;
  return <motion.a href={href} onClick={continuation ? undefined : trackCheckoutIntent} whileHover={reducedMotion ? undefined : {
    y: -2,
    scale: 1.01,
    boxShadow: "0 8px 18px rgba(23, 25, 20, 0.16)"
  }} whileTap={reducedMotion ? undefined : {
    scale: 0.98
  }} transition={{
    duration: 0.2,
    ease: [0.22, 1, 0.36, 1]
  }} className={`group relative inline-flex w-full items-center justify-center gap-2 overflow-hidden rounded-[11px] bg-lime-400 px-5 font-black uppercase tracking-tight text-stone-950 shadow-none focus:outline-none focus:ring-4 focus:ring-lime-300 ${compact ? "min-h-[44px] py-3 text-xs" : "min-h-[54px] py-4 text-sm sm:w-auto sm:px-7 sm:text-base"} ${className}`} data-id="element-4" data-mp="10adfznt3ve0o">
      {!reducedMotion && <motion.span aria-hidden="true" className="pointer-events-none absolute inset-y-0 w-10 -skew-x-12 bg-white/45" initial={{
      x: "-260%"
    }} animate={{
      x: ["-260%", "420%", "420%"]
    }} transition={{
      duration: 0.65,
      times: [0, 0.92, 1],
      ease: [0.22, 1, 0.36, 1],
      repeat: Infinity,
      repeatDelay: 2.35
    }} data-id="element-5" data-mp="3jx76hjtw57u3" />}
      <span className="relative z-10" data-id="element-6" data-mp="1jzab7lgnbls">{children}</span>
      <ArrowIcon className={`relative z-10 h-4 w-4 ${continuation ? "group-hover:translate-y-0.5" : "group-hover:translate-x-1"} transition-transform duration-200 [transition-timing-function:cubic-bezier(0.22,1,0.36,1)]`} aria-hidden="true" data-id="element-7" data-mp="1lahlhe471hn" />
    </motion.a>;
}